import { http } from '@/utils/http'

// 日志登记
export const logAdd = () => {
  return http.post('/sys/log/add', {})
}

// 获取字典
export const getDictItems = (dictCode) => {
  return http.get(`/sys/dict/getDictItems/${dictCode}`, {})
}
//获取oss签名
export const getSignature = () => {
  return http.get(`/api/ali/oss/getSignature`, {})
}
//权限
export const getPermissionList = () => {
  return http.get(`/sys/permission/getUserPermissionByToken`, {})
}

export const getSignatureUrl = (fileName) => {
  return http.post(`/api/ali/oss/signatureUrl`, fileName)
}

export const getOauth = (code) => {
  return http.post(`/api/sys/weixin/getOauth`, { code })
}